import React from "react";
import HomeSwiper from "../CommonComponets/HomeSwiper";

export default function HomePage() {
  return (
    <div id="home" className="pt-20 h-screen border">
      <div className="mt-20">
        <HomeSwiper />
      </div>
    </div>
  );
}
